import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
import VueSwal from 'vue-swal'
import store from './store'
import VueTheMask from 'vue-the-mask'
import helpers from './helpers'
import AuthService from './services/AuthService'
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import dayjs from 'dayjs';

import './plugins/dayjs'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'animate.css/animate.css'
import './assets/css/main.css'

const base_server = process.env.VUE_APP_BASE_SERVER;
const audio = new Audio("https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-gestor/lebot-bell.mp3");
audio.loop = true;

Vue.use(VueResource);
Vue.use(VueSwal);
Vue.use(VueTheMask);
Vue.use(helpers);

const socketConnection = SocketIO(base_server + 'chat', {
  autoConnect: false
});
Vue.use(new VueSocketIO({ debug: false, connection: socketConnection }));

Vue.mixin({
  data () {
    return {
      base_server
    }
  },

  methods: {
    playNotification() {
      if (audio.paused && this.$store.state.canPlay) {
        audio.play();
      }
    },

    pauseNotification() {
      if (!audio.paused) {
        audio.pause();
        audio.currentTime = 0;
      }
    }
  }
});

Vue.config.productionTip = false;
Vue.http.options.emulateHTTP = true;
Vue.http.options.root = base_server;

AuthService.configure({
  socket: socketConnection,
  onAuthFailure: () => {
    store.commit('logout');
    window.location.href = '/';
  }
});

Date.prototype.toDateInputValue = (function() {
  let local = new Date(this);
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
  return local.toJSON().slice(0,10);
});

Vue.filter('hour', function (value) {
  if (!value) return '';

  const d = dayjs(value);
  if (!d.isValid()) return '';

  return d.format('HH:mm');
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
